import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Task } from "src/api/types";
import MessagesList from "src/components/Messaging/components/MessagesList";
import NewMessageForm from "src/components/Messaging/components/MessagesList/components/NewMessageForm";
import { MatchParam } from "src/constants/matches";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";
import { useManageModal } from "src/hooks/useManageModal";
import TaskWrapper from "src/wrappers/TaskWrapper";
import ForwardTaskModal from "../ForwardTaskModal";
import { useWaitingRoom } from "src/context/WaitingRoomProvider/useWaitingRoom";

interface Props {
  task: Task;
  onSuccess: () => void;
}

const UnreadMessageTask = ({ task, onSuccess }: Props) => {
  const { waitRoomId } = useParams<MatchParam<"WAIT_ROOM_ID">>();
  const [openModal, modalActions] = useManageModal();
  const { setSelected } = useSelection();
  const forwardingReason = useWaitingRoom((room) => room.forwarding_reason);

  const threadSlug = useMemo(
    () => task.metadata?.thread_slug,
    [task.metadata?.thread_slug]
  );

  const handleForwarding = useCallback(() => {
    if (waitRoomId == null) return null;

    const roomId = Number(waitRoomId);

    setSelected([roomId]);
    queueMicrotask(() => modalActions.handleOpen());
  }, [modalActions, setSelected, waitRoomId]);

  return (
    <TaskWrapper
      task={task}
      action={handleForwarding}
      forwardingReason={forwardingReason || ""}
    >
      <Stack
        height="100%"
        sx={{ overflowY: "auto", background: "white", borderRadius: "10px" }}
      >
        {threadSlug ? (
          <>
            <MessagesList threadSlug={threadSlug} />
            <NewMessageForm onSuccess={onSuccess} threadSlug={threadSlug} />
          </>
        ) : (
          <Typography>Could not find thread</Typography>
        )}
      </Stack>
      <ForwardTaskModal
        open={openModal}
        handleClose={modalActions.handleClose}
      />
    </TaskWrapper>
  );
};

export default UnreadMessageTask;
